// extracted by mini-css-extract-plugin
export default {"button":"styles_button__kEIzP","pinned":"styles_pinned__pkg3c"};